export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14049.832f4b55.jpg";